<template>
    <!-- 语音直播卡片 -->
    <div
        :class="['liveCardWrap']"
        @click.stop.prevent="handleClickAudioDetail"
    >
        <div class="liveCardMain">
            <div
                class="liveCardLeft"
                :style="{
                    backgroundImage: 'url(' + info.cover + ')'
                }"
            >
                <div class="liveCardState">
                    <div class="liveCardStateIcon">
                        <img v-if="info.status == 'pending'" src="https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoCard_icon.gif" alt="">
                        <img v-if="info.status == 'started' || info.status == 'ended'" src="https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoCard_icon.svg" alt="">
                    </div>
                    <div class="liveCardStateName">{{info.hot}}</div>
                </div>
                <div class="liveCardInfo" v-if="info.status == 'pending'">
                    <div
                        :style="{
                            backgroundImage: 'url(' + info.avatar + ')'
                        }"
                    ></div>
                    <span>{{ info.nickname }}</span>
                </div>
                <div class="liveCardVideo" v-if="info.room_state == '2'">
                    <button></button>
                </div>
            </div>
            <div class="liveCardRight">
                <div class="liveCardTitle">
                    <p>{{info.title}}</p>
                </div>
                <div class="liveCardBrief">
                    <p>{{info.desc}}</p>
                </div>
                <div class="liveCardBtn">
                    <button>{{info.tips}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "audioLiveCard",
    props: {
        info: {
            type: Object
        },
        userInfo: {
            type: Object
        },
    },
    data() {
        return {
            ending: false,
        }
    },
    created() {
        // // preview_live_time
        // // 判断一下当前的时间
        // let nowDate = new Date().getTime();
        // // 
        // let cardTime = this.info.preview_live_time;
        // if(typeof cardTime == 'string') {
        //     cardTime = cardTime.replace(/-/g, '/')
        // }
        // let cardDate = new Date(cardTime).getTime();

        // if(nowDate > cardDate) {
        //     this.ending = true;
        // } else {
        //     this.ending = false;
        // }
    },
    methods: {
        handleClickAudioDetail() {
            console.info(this.info)
            this.openNative("audio_live_page", {
                id: this.info.id,
                query: this.info
            })
        },
        // 跳转APP页面
        openNative(type, query = {}) {
            let params = {
                kind: type, // 类型
            };

            params = {
                ...params,
                ...query
            }

            switch(type) {
                case "audio_live_page": // 语音直播间
                    break;
            }

            this.$srH5CallNativeMethodApp('call_Native',params)
        },
    },
    computed: {}
}
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.liveCardWrap {
    padding:10px 12px 12px;
    box-sizing: border-box;

    .liveCardMain {
        width: 100%;
        height: rem2(96px);
        border-radius: 10px;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        background-color: $a-white;
        border: rem2(1px) solid $a-bordr-c;

        .liveCardLeft {
            width: rem2(137px);
            height: rem2(96px);
            position: relative;
            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoCard_bg.png");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            padding: rem2(8px);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            >div{
                position: relative;
                z-index: 2;
            }

            .liveCardState {
                width: max-content;
                height: 19px;
                border-radius: 9.5px;
                background: rgba(0, 0, 0, 0.30);
                display: inline-flex;
                flex-direction: row;
                align-items: center;
                padding-right: 6.5px;
                box-sizing: border-box;

                .liveCardStateIcon {
                    width: 19px;
                    height: 19px;
                    border-radius: 50%;
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoCard_circle.svg");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 3.5px;

                    img {
                        width: 10px;
                        height: auto;
                        display: block;
                    }
                }

                .liveCardStateName {
                    color: #FFF;
                    font-size: 10px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 19px; /* 120% */
                    letter-spacing: 0.3px;
                }
            }

            .liveCardInfo {
                width: auto;
                height: 21px;
                line-height: 21px;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;

                & > div {
                    width: 21px;
                    height: 21px;
                    border-radius: 50%;
                    overflow: hidden;
                    background-color: transparent;
                    background-size: 21px 21px;
                    background-position: left center;
                    background-repeat: no-repeat;
                }

                & > span {
                    color: #FFF;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    margin-left: 4px;
                }
            }

            .liveCardVideo {
                display: flex;
                flex-direction: row-reverse;

                button {
                    width: 27px;
                    height: 27.5px;
                    background-color: transparent;
                    background-image: url("https://cdncos.aigupiao.com/assets/app/h5/user_home/liveInfoVideo.svg");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    background-position: center;
                    border: none;
                    outline: none;
                }
            }
        }

        .liveCardRight {
            flex: 1;
            overflow: hidden;
            padding: 7px 5px 5px 14px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .liveCardTitle {

                p {
                    color: $a-normal;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: bold;
                    line-height: 16px; /* 112.5% */
                }
            }

            .liveCardBrief {

                p {
                    color: $a-grey-a93;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 16px; /* 133.333% */
                }
            }

            .liveCardBtn {
                button {
                    border-radius: 50px;
                    padding: 0 10px;
                    height: 26px;
                    line-height: 26px;
                    background-color: #FE484a;
                    font-size: 14px;
                    color: #FFF;
                    border: none;
                    box-sizing: border-box;
                }
            }
        }
    }
}
</style>